import $http from '@vue-util/http';

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: {},
    hasIndicator: false,
    promise: null,
  }),
  getters: {
    getTotalNotifications: (state) => {
      let notificationCount = 0;
      const { linkPropCardsToFusion, addCardToWallet, loyaltyRewardCards, makePropCardDefault, enrollLoyalty, orderInfo, starRewardsDowngradeInfo } =
        state.notifications;

      if (addCardToWallet) {
        notificationCount += 1;
      }

      if (linkPropCardsToFusion && linkPropCardsToFusion.cardNumbers) {
        notificationCount += linkPropCardsToFusion.cardNumbers.length;
      }

      if (loyaltyRewardCards && loyaltyRewardCards.length) {
        notificationCount += loyaltyRewardCards.length;
      }
      if (makePropCardDefault) {
        notificationCount += 1;
      }
      if (enrollLoyalty) {
        notificationCount += 1;
      }
      if (orderInfo && orderInfo.length) {
        notificationCount += orderInfo.length;
      }
      if (starRewardsDowngradeInfo) {
        notificationCount += 1;
      }

      return notificationCount;
    },
  },
  actions: {
    setNotifications(payload) {
      this.notifications = payload;
    },
    setIndicator(payload) {
      this.hasIndicator = payload;
    },
    setNotificationPromise(payload) {
      this.promise = payload;
    },
    async fetchNotifications({ userId, pageType, deviceType }) {
      if (this.promise) {
        return this.promise;
      }

      const promise = $http
        .post(`/account-xapi/api/notifications/user/${userId}?_pageType=${pageType}&_deviceType=${deviceType}&timeStamp=${Date.now()}`)
        .then((response) => this.setNotifications(response.data.userNotifications))
        .catch(() => {});

      this.setNotificationPromise(promise);
      return promise;
    },
  },
});
